import { Box, FlexContainer } from "@/components/Atoms";
import Typography from "@/foundation/Typography/V2";
import styled from "styled-components";

export const HeaderWrapper = styled(FlexContainer)`
  display: flex;
  width: 100vw !important;
  padding: 60px 140px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
  max-width: unset;
  background: var(
    --gradient-primary-800700265-deg,
    linear-gradient(27deg, #53389e 8.33%, #6941c6 91.67%)
  );

  @media (max-width: 650px) {
    padding: 60px 16px;
    background: linear-gradient(180deg, #5b3ebf 0%, #6e4ea3 100%);
    width: 100%;
  }
`;

export const HeaderTitle = styled(Typography)`
  color: #ffffff;
  text-align: center;
  font-family: var(--man);
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;

  @media (max-width: 650px) {
    font-size: 24px;
    line-height: 32px;
    align-self: stretch;
  }
`;

export const SearchAndDropdownWrapper = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 650px) {
    width: 100%;
  }
`;
